import { Feliz_Router_Router__Router_navigatePath_Static_Z400814D9, Feliz_Router_Router__Router_formatPath_Static_Z400814D9, Feliz_Router_Router__Router_getCurrentParsedUrl_Static } from "../Prelude.fs.js";
import { Page__OnClick_Z11029FF1, Page__get_Href, Page, ProjectPage, EntityType__ToProperString, EntityType__ToProperPluralString, SearchParams, SearchParams__get_toKeyValue } from "../ClientTypes.fs.js";
import { ofList, FSharpMap__TryFind, FSharpMap__Add } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { createElement } from "react";
import React from "react";
import { equals, comparePrimitives, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty as empty_1, cons, singleton as singleton_1, choose, tryPick, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { useFeliz_React__React_useSearchType_Static, useFeliz_React__React_useTypedParams_Static } from "../hooks/UseRouter.fs.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Impl_createRemoveOptions, Impl_adjustPassive, Impl_defaultPassive } from "../fable_modules/Feliz.Listeners.1.1.0/./Listener.fs.js";
import { useEffect } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { PropHelpers_createOnKey } from "../fable_modules/Feliz.2.9.0/./Properties.fs.js";
import { key_enter } from "../fable_modules/Feliz.2.9.0/Key.fs.js";
import { useFeliz_React__React_useProjectContext_Static } from "../hooks/UseProjectContext.fs.js";
import { logOut } from "../Api/Auth.fs.js";
import "./Header.scss";


function downdownButton(close, entityType) {
    const patternInput = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
    const currentUrl = patternInput[0];
    let newQuery;
    const tupledArg = SearchParams__get_toKeyValue(new SearchParams(0, [entityType]));
    newQuery = FSharpMap__Add(patternInput[1], tupledArg[0], tupledArg[1]);
    const path = Feliz_Router_Router__Router_formatPath_Static_Z400814D9(currentUrl, newQuery);
    return createElement("a", createObj(Helpers_combineClasses("dropdown-item", ofArray([["children", EntityType__ToProperPluralString(entityType)], ["href", path], ["onClick", (e) => {
        e.preventDefault();
        close();
        Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(currentUrl, newQuery);
    }]]))));
}

function Search() {
    let elems_11, elms_3, elems_7, value_42, elms_5, elems_9, elms_4;
    const patternInput = reactApi.useState(false);
    const setMenuOpen = patternInput[1];
    const menuOpen = patternInput[0];
    const ref = reactApi.useRef(undefined);
    const openMenu = reactApi.useCallback((_arg) => {
        setMenuOpen(true);
    }, []);
    const closeMenuButton = reactApi.useCallback(() => {
        setMenuOpen(false);
    }, []);
    const closeMenu = reactApi.useCallback((_arg_1) => {
        setMenuOpen(false);
    }, []);
    const toggle = reactApi.useCallback((_arg_2) => {
        setMenuOpen(!menuOpen);
    }, []);
    const searchParams = useFeliz_React__React_useTypedParams_Static();
    const entityTypeOpt = useFeliz_React__React_useSearchType_Static();
    const query_1 = defaultArg(tryPick((p) => {
        if (p.tag === 1) {
            return p.fields[0];
        }
        else {
            return undefined;
        }
    }, searchParams), "");
    const patternInput_1 = reactApi.useState(query_1);
    const searchText = patternInput_1[0];
    let goSearch;
    const dependencies_1_4 = [searchText];
    goSearch = reactApi.useCallback(() => {
        const patternInput_2 = Feliz_Router_Router__Router_getCurrentParsedUrl_Static();
        const searchType = new SearchParams(0, [defaultArg(entityTypeOpt, "activity")]);
        const infoPanel = map((ip) => ["ip", ip], FSharpMap__TryFind(patternInput_2[1], "ip"));
        Feliz_Router_Router__Router_navigatePath_Static_Z400814D9(patternInput_2[0], ofList(choose((x) => x, ofArray([SearchParams__get_toKeyValue(new SearchParams(1, [searchText])), SearchParams__get_toKeyValue(searchType), infoPanel])), {
            Compare: comparePrimitives,
        }));
    }, dependencies_1_4);
    const elemRef = ref;
    const callback = closeMenu;
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_5 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_5);
    let removeOptions;
    const dependencies_1_6 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_6);
    let fn;
    const dependencies_1_7 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_8 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_8);
    let removeOptions_1;
    const dependencies_1_9 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_9);
    let fn_1;
    const dependencies_1_10 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_10);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    return createElement("div", createObj(Helpers_combineClasses("field", ofArray([op_PlusPlus(["className", "search-bar"], ["className", "has-addons"]), (elems_11 = [(elms_3 = singleton_1(createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay(() => append(singleton(["ref", ref]), delay(() => append(menuOpen ? singleton(["className", "is-active"]) : empty(), delay(() => {
        let elems_5, elms, elems_1, elems, elms_2, elms_1;
        return singleton((elems_5 = [(elms = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", toggle], (elems_1 = [createElement("span", createObj(toList(delay(() => append(singleton(["className", "is-size-7-mobile"]), delay(() => {
            const matchValue_2 = entityTypeOpt;
            return (matchValue_2 == null) ? singleton(["children", "Choose"]) : singleton(["children", EntityType__ToProperString(matchValue_2)]);
        })))))), createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], (elems = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-angle-down"])), [])], ["children", reactApi.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), createElement("div", {
            className: "dropdown-trigger",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_2 = singleton_1((elms_1 = ofArray([downdownButton(closeMenuButton, "activity"), downdownButton(closeMenuButton, "area"), downdownButton(closeMenuButton, "certification"), downdownButton(closeMenuButton, "document"), downdownButton(closeMenuButton, "documentTracking"), downdownButton(closeMenuButton, "facility"), downdownButton(closeMenuButton, "location"), downdownButton(closeMenuButton, "module"), downdownButton(closeMenuButton, "nonConformanceReport"), downdownButton(closeMenuButton, "preservation"), downdownButton(closeMenuButton, "productionUnit"), downdownButton(closeMenuButton, "punchList"), downdownButton(closeMenuButton, "scopeOfWork"), downdownButton(closeMenuButton, "subsystem"), downdownButton(closeMenuButton, "system"), downdownButton(closeMenuButton, "tag"), downdownButton(closeMenuButton, "technicalQuery")]), createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))), createElement("div", {
            className: "dropdown-menu",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))]));
    })))))))))), createElement("div", {
        className: "control",
        children: reactApi.Children.toArray(Array.from(elms_3)),
    })), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], (elems_7 = [createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["className", "search-bar-input"], ["onChange", (ev_2) => {
        patternInput_1[1](ev_2.target.value);
    }], ["onKeyDown", (ev_3) => {
        PropHelpers_createOnKey(key_enter, (_arg_4) => {
            goSearch();
        }, ev_3);
    }], (value_42 = searchText, ["ref", (e) => {
        if (!(e == null) && !equals(e.value, value_42)) {
            e.value = value_42;
        }
    }]), ["placeholder", "Search..."]])))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), (elms_5 = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "search-button"], ["onClick", (_arg_5) => {
        goSearch();
    }], (elems_9 = [(elms_4 = singleton_1(Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-search"])), [])), createElement("span", {
        className: "icon",
        children: reactApi.Children.toArray(Array.from(elms_4)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))), createElement("div", {
        className: "control",
        children: reactApi.Children.toArray(Array.from(elms_5)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
}

export function Header() {
    let elems_11, elms, elems_10, elems_9;
    const projectContext = useFeliz_React__React_useProjectContext_Static();
    const patternInput = reactApi.useState(false);
    const showOptions = patternInput[0];
    const setShowOptions = patternInput[1];
    const ref = reactApi.useRef(undefined);
    const elemRef = ref;
    const callback = reactApi.useCallback((_arg) => {
        setShowOptions(false);
    }, []);
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_1 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_1);
    let removeOptions;
    const dependencies_1_2 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_2);
    let fn;
    const dependencies_1_3 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_3);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_4 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_4);
    let removeOptions_1;
    const dependencies_1_5 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_5);
    let fn_1;
    const dependencies_1_6 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_6);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    const epmLogo = createElement("img", {
        src: "/icon.svg",
        className: "epm-logo",
        alt: "EPM",
    });
    const defaultProjectIcon = createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "epm-logo"], ["children", Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-project-diagram"]), new Fa_IconOption(0, [new Fa_ISize(2, [])])]), [])]]))));
    const projectPage = new Page(1, [new ProjectPage(0, [projectContext.ProjectId])]);
    return createElement("nav", createObj(Helpers_combineClasses("navbar", ofArray([["className", "header-container"], ["className", "px-0"], ["className", "is-primary"], ["className", "is-radiusless"], ["className", "is-fixed-top"], (elems_11 = [(elms = singleton_1(createElement("a", {
        href: Page__get_Href(new Page(0, [])),
        onClick: (e) => {
            Page__OnClick_Z11029FF1(new Page(0, []), e);
        },
        className: "navbar-item",
        title: "Project Selection",
        children: epmLogo,
    })), createElement("div", {
        className: "navbar-brand",
        children: reactApi.Children.toArray(Array.from(elms)),
    })), createElement("div", createObj(Helpers_combineClasses("navbar-item", ofArray([["className", "is-expanded"], ["children", createElement(Search, null)]])))), createElement("div", createObj(Helpers_combineClasses("navbar-end", ofArray([["className", "project-info"], (elems_10 = [createElement("div", createObj(Helpers_combineClasses("navbar-item", ofArray([["className", "is-clickable"], ["onClick", (_arg_1) => {
        setShowOptions(!showOptions);
    }], (elems_9 = [createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay(() => append(singleton(["className", "is-right"]), delay(() => append(singleton(["ref", ref]), delay(() => append(showOptions ? singleton(["className", "is-active"]) : empty(), delay(() => {
        let elems_8;
        return singleton((elems_8 = toList(delay(() => append(singleton(createElement("div", createObj(ofArray([op_PlusPlus(["className", "is-hidden-mobile"], ["className", "project-name"]), ["children", projectContext.Config.Name]])))), delay(() => {
            let matchValue_2;
            return append((matchValue_2 = projectContext.Config.ImageUrl, (matchValue_2 == null) ? singleton(defaultProjectIcon) : singleton(createElement("img", {
                className: "project-thumbnail",
                src: matchValue_2,
                alt: projectContext.Config.Name,
            }))), delay(() => {
                let elems_7, elms_2, iconProps, elems_1, iconProps_2, elems_2, iconProps_4, elems_3, elms_1, iconProps_6, elems_4;
                return singleton(createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton_1((elems_7 = [(elms_2 = ofArray([createElement("a", createObj(Helpers_combineClasses("dropdown-item", ofArray([["href", Page__get_Href(projectPage)], ["onClick", (e_1) => {
                    Page__OnClick_Z11029FF1(projectPage, e_1);
                }], ["children", (iconProps = singleton_1(["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-home"])), [])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems_1 = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => iconProps))))), createElement("span", createObj(toList(delay(() => [["children", "Project Home"]]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))]])))), createElement("a", createObj(Helpers_combineClasses("dropdown-item", ofArray([["href", "https://app.digitalnorthsea.com"], ["rel", "noopener noreferrer"], ["target", "_blank"], ["children", (iconProps_2 = singleton_1(["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-map-marked"])), [])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems_2 = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => iconProps_2))))), createElement("span", createObj(toList(delay(() => [["children", "DNS"]]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))]])))), createElement("a", createObj(Helpers_combineClasses("dropdown-item", ofArray([["href", "https://help.unasys.com"], ["rel", "noopener noreferrer"], ["target", "_blank"], ["children", (iconProps_4 = singleton_1(["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-question-circle"])), [])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems_3 = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => iconProps_4))))), createElement("span", createObj(toList(delay(() => [["children", "Help & Support"]]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))]])))), createElement("hr", createObj(Helpers_combineClasses("dropdown-divider", empty_1()))), (elms_1 = singleton_1(createElement("div", createObj(Helpers_combineClasses("dropdown-item", ofArray([["className", "is-clickable"], ["children", (iconProps_6 = singleton_1(["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-sign-out-alt"])), [])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems_4 = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay(() => iconProps_6))))), createElement("span", createObj(toList(delay(() => [["children", "Sign out"]]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))], ["onClick", (_arg_2) => {
                    logOut();
                }]]))))), createElement("div", {
                    className: "dropdown-content",
                    children: reactApi.Children.toArray(Array.from(elms_1)),
                }))]), createElement("div", {
                    className: "dropdown-content",
                    children: reactApi.Children.toArray(Array.from(elms_2)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_7))]))))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_8))]));
    })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
}

